import React from 'react';
import styled from 'styled-components';

const Td = styled.td`
  width: 150px;
  padding-right: 50px;
  text-align: right;
  padding-left: 50px;
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => (props.isBold ? 'bold' : 'unset')};
`;

export const ProviderColumn = ({ children, fontSize, isBold = false, colSpan = 1 }) => {
  return (
    <Td colSpan={colSpan} fontSize={fontSize} isBold={isBold}>
      {children}
    </Td>
  );
};
